import PropTypes from 'prop-types';

// https://github.com/TanStack/table/blob/v7/docs/src/pages/docs/api/useTable.md

const ColumnPropType = PropTypes.shape({
  id: PropTypes.string,
  isVisible: PropTypes.bool,
  render: PropTypes.func,
  totalLeft: PropTypes.number,
  totalWidth: PropTypes.number,
  getHeaderProps: PropTypes.func.isRequired,
  getFooterProps: PropTypes.func.isRequired,
  toggleHidden: PropTypes.func,
  getToggleHiddenProps: PropTypes.func,
  // custom props
  className: PropTypes.string,
});

/**
 * @typedef {object} ReactTableColumnPropType
 * @property {string} id
 * @property {boolean} isVisible
 * @property {Function} render
 * @property {number} totalLeft
 * @property {number} totalWidth
 * @property {Function} getHeaderProps
 * @property {Function} getFooterProps
 * @property {Function} toggleHidden
 * @property {Function} getToggleHiddenProps
 * @property {string} [className]
 */

const CellPropType = PropTypes.shape({
  getCellProps: PropTypes.func, // Technically required, but not added to cell until prepareRow is called
  column: ColumnPropType,
  render: PropTypes.func, // Technically required, but not added to cell until prepareRow is called
  value: PropTypes.any,
});

/**
 * @typedef {object} ReactTableCellPropType
 * @property {Function} getCellProps
 * @property {ReactTableColumnPropType} column
 * @property {Function} render
 * @property {any} value
 */

const RowPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  getRowProps: PropTypes.func, // Technically required, but not added to row until prepareRow is called
  getToggleRowSelectedProps: PropTypes.func,
  isSelected: PropTypes.bool,
  cells: PropTypes.arrayOf(CellPropType),
  values: PropTypes.object,
  original: PropTypes.object,
});

/**
 * @typedef {object} ReactTableRowPropType
 * @property {string} id
 * @property {Function} getRowProps Technically required, but not added to row until prepareRow is called
 * @property {Function} [getToggleRowSelectedProps]
 * @property {boolean} [isSelected]
 * @property {ReactTableCellPropType[]} cells
 * @property {object} values
 * @property {object} original
 */

const HeaderGroupPropType = PropTypes.shape({
  getHeaderGroupProps: PropTypes.func.isRequired,
  headers: PropTypes.arrayOf(ColumnPropType),
});

/**
 * @typedef {object} ReactTableHeaderGroupPropType
 * @property {Function} getHeaderGroupProps
 * @property {ReactTableColumnPropType[]} headers
 */

// PropTypes for the Cell component provided in the column definition
const CellPropTypes = {
  cell: CellPropType.isRequired,
  row: RowPropType.isRequired,
  value: PropTypes.any,
};

/**
 * @typedef {object} ReactTableCellPropTypes
 * @property {ReactTableCellPropType} cell
 * @property {ReactTableRowPropType} row
 * @property {any} value
 */

export { ColumnPropType, RowPropType, HeaderGroupPropType, CellPropTypes };
